<template>
  <div class="animated fadeIn list-of-po">
    <b-card>
      <div slot="header">Report - Inventory Stock
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxlsInventoryStock()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="10">
                  <b-input-group >
                    <b-input-group-prepend><label style="width:140px !important;">Stock Opname Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="10">
                  <b-input-group>
                  <b-input-group-prepend><label style="width:140px !important;">Item Category</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.itemcategory" :plain="true" :options="itemCategories"></b-form-select>
                  <b-input-group-prepend><label class="ml-3" style="width:80px !important;">Item Name</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                  <b-input-group-append>
                  <b-btn variant="primary" @click="lkuItemShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
                </b-input-group>
                  </b-col>
            </b-row>
        
        </b-col>

        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="custgroup" @change="reloaddata"></b-form-select> 
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-form-input v-model="tblData.CustName" @change="tbldata.customer_id=''" placeholder="Customer"></b-form-input>
              <b-input-group-append>
                <b-btn variant="primary" @click="lkuCustShow=true"> <i class="fa fa-search"></i></b-btn>
              </b-input-group-append>
              <b-input-group-prepend><label class="ml-4" style="width:60px !important;">Stock By</label></b-input-group-prepend>
              <b-form-input v-model="tblData.byStock" placeholder="%Nama User" ></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label class='label-input-group'>View Option</label></b-input-group-prepend>
              <b-form-radio-group  v-model="viewOption" class="mt-1">
                  <b-form-radio v-model="viewOption" value="Header">Header/Summary</b-form-radio>
                  <b-form-radio v-model="viewOption" value="Lines">Line/Items</b-form-radio>
              </b-form-radio-group>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <div class="clearfix" style="padding:10px 0px 10px 0px;">
              <div class="float-right">
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i> Clear Filter</b-button>
              </div>
            </div> -->
        </b-col>

      </b-row>
      <b-table
        class="mb-0 mt-3"
        ref="table"
        outlined small 
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>  

      <template v-slot:thead-top="data">
            <b-tr>
              <b-th colspan="3">.&nbsp;</b-th>
              <b-th colspan="2" class="text-center" variant="success">Etalase Masuk Akhir</b-th>
              <b-th colspan="2" class="text-center" variant="primary">Stock Opname</b-th>
              <b-th colspan="1">&nbsp;</b-th>
            </b-tr>
          </template>
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

        <template v-slot:cell(tglStock)="data">
          {{ data.item.tglStock | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(nilainett)="data">
          {{data.item.nilainett | numFormat}}
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{data.item.nilaippn | numFormat}}
        </template>
        <template v-slot:cell(nilaidue)="data">
          {{data.item.nilaidue | numFormat}}
        </template>
        <template v-slot:cell(nilaiduereceiving)="data">
          {{data.item.nilaiduereceiving | numFormat}}
        </template>
        <template v-slot:cell(totitemreceived)="data">
          <span v-if="(data.item.totitemreceived>0)"> {{data.item.totitemreceived | numFormat}} of {{data.item.totitemordered | numFormat}} items </span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
        <b-modal v-model="lkuCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
          <lku-cust @click="onSelectCust" :customer_group="tblData.customer_group" ></lku-cust>
        </b-modal> 
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem" jasa="0" isactive="1" :formdata="itemList"></lku-item>
        </b-modal>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import procure from "../../apis/bakeryorder";
import dropdown from "../../data/dropdown";
// import lkuSupplier from "../lookup/lkuSupplier";
// import lkuCustomer from "../lookup/lkuCustomer";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCust from "../lookup/lkuCustomerGroup";
import customer from "../../apis/bakerycustomer";
import item from "../../apis/bakeryitem";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading, lkuItem, lkuCust},
  mixins: [validationMixin],
  validations: {
        forecastcustomer: {
            customer_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
        model: {
            tgl1: { required },
            tgl2: { required }
        },
  }, 
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      // showFrmVendor:false,
      // lkuVendorShow:false,
      lkuCustShow: false,
      // forecastvendor:{vendor_id:'', tgl1:'', tgl2:''},
      showFrmCustomer:false,
      forecastcustomer:{customer_id:'', tgl1:'', tgl2:''},
      model:{tgl1:'', tgl2:''},
      itemCategories: [
        { text: '-- All --', value: '' }
      ],
      custgroup:[
          { value: '', text: '-- ALL--' }
      ],
      // lkuCustomerShow:false,
      lkuItemShow:false,
      disabledCloseVoid:true,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      viewOption:'Lines',
      reportUrl: `${location.origin}/#load`,
        items: [],
      tblData: {
        customerinfo:'',
        customer_group:'',
        customer_id:'',
        CustName:'',
        customer: '',
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment().format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),
        // tgl3:this.$store.state.user.tglaktif,
        // tgl4:moment().format('YYYY-MM-DD'),
        sortBy: 'modified',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:'',
        itemcategory:''
      },
      itemList:{},
      limit:15,
      pagination: false,      
      tblFields: [
          {
            key: "CustName",
            thStyle: "width:250px",
            label: "Customer",
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "tanggal",
            label: "Date",
            thStyle: "width:120px",
            variant: "success",
            sortable: true
          },
          {
            key: "qtyReceiptEtalase",
            label: "Qty",
            thStyle: "width:80px",
            variant: "success",
            sortable: true
          },
          {
            key: "tglStock",
            label: "Date",
            thStyle: "width:120px",
            variant: "primary",
            sortable: true
          },
          {
            key: "qtyStock",
            label: "Qty",
            thStyle: "width:80px",
            variant: "primary",
            sortable: true
          },
          {
            key: "byStock",
            label: "Stock By",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ],
      model:{},
      postGroups:[],
      approvalStatus : dropdown.approvalStatus,
      outstandSlct : dropdown.openClose,
      forecastcustomer:{
        closeVoid:'closed',
        closevoidnote:'',
        options: [
          { text: 'Closed', value: 'closed' },
          { text: 'Void', value: 'void' },
        ]
      },
      forecastvendor:{trackStatus:''},
      showStatusUpdate:false,      
    };
  },
  computed: {
    invalidFcCustomer() {
      this.$v.forecastcustomer.$touch();
      return this.$v.forecastcustomer.$invalid;
    },
    invalidFcVendor() {
      this.$v.forecastvendor.$touch();
      return this.$v.forecastvendor.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },
    
    
    viewOption : function(newval) {
      if (newval=='Lines') {
        this.tblFields= [
          {
            key: "CustName",
            thStyle: "width:250px",
            label: "Customer",
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "tanggal",
            label: "Date",
            thStyle: "width:120px",
            variant: "success",
            sortable: true
          },
          {
            key: "qtyReceiptEtalase",
            label: "Qty",
            thStyle: "width:80px",
            variant: "success",
            sortable: true
          },
          {
            key: "tglStock",
            label: "Date",
            thStyle: "width:120px",
            variant: "primary",
            sortable: true
          },
          {
            key: "qtyStock",
            label: "Qty",
            thStyle: "width:80px",
            variant: "primary",
            sortable: true
          },
          {
            key: "byStock",
            label: "Stock By",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push({
            key: `${dims[i].value}Txt`,
            label: dims[i].text,
            sortable: true
          });
        }
      } else {
        this.tblFields= [
        {
            key: "CustName",
            thStyle: "width:250px",
            label: "Customer",
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "tanggal",
            label: "Date",
            thStyle: "width:120px",
            variant: "success",
            sortable: true
          },
          {
            key: "qtyReceiptEtalase",
            label: "Qty",
            thStyle: "width:80px",
            variant: "success",
            sortable: true
          },
          {
            key: "tglStock",
            label: "Date",
            thStyle: "width:120px",
            variant: "primary",
            sortable: true
          },
          {
            key: "qtyStock",
            label: "Qty",
            thStyle: "width:80px",
            variant: "primary",
            sortable: true
          },
          {
            key: "byStock",
            label: "Stock By",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ];
      }
      
      let newFields = [];
      this.tblFields.map((data,index)=>{
        if(!data.hide){
          newFields.push(data);
        }
      })
      this.tblFields = newFields;
      this.refresh();
    },
  },

  created: async function(){
    try {
      const [custgroup,itemCategories] = await Promise.all([
                customer.group(),item.group()
                ]) ;
            if(custgroup){
                 custgroup.map((data)=>{
                    this.custgroup.push({
                        value:data.value,
                        text:data.text
                    });
                });
            }
            if(itemCategories){
                 itemCategories.map((data)=>{
                    this.itemCategories.push({
                        value:data.nama,
                        text:data.nama
                    });
                });
            }
    } catch (error) {
        this.isLoading = false;
          console.log('error : ', error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
    }

  },

  methods: {
    // onSelectLkuCustomer: async function (_selected) {
    //     this.forecastcustomer.customer_id = _selected.customer_id;
    //     this.forecastcustomer.CustCode = _selected.CustCode;
    //     this.forecastcustomer.CustName = _selected.CustName;
    //     this.forecastcustomer.customer = `${_selected.CustName} | ${_selected.CustCode}`;
    //     this.tblData.CustName = _selected.CustName;
    //     this.lkuCustomerShow=false;
    // },    
    // onSelectLkuVendor: async function (_selected) {
    //     this.forecastvendor.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
    //     this.forecastvendor.vendor = _selected.vendor_code;
    //     this.forecastvendor.vendor_id = _selected.vendor_id;
    //     this.lkuVendorShow=false;
    // },
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemcode = lkuData.selected.itemcode;
        this.tblData.itemname = lkuData.selected.itemname;
        this.lkuItemShow=false;
    },
    onSelectCust(_selected) {
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.lkuCustShow = false;
    },
    // customerChange: function () {
    //     this.tblData.customer_id = '';
    // },
    // customerChangeTrfIn: function () {
    //     this.tblData.customer_id = '';
    // },
    itemChange: function () {
        this.tblData.itemno = '';
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.polist) {
            this.tblData[key] = filter.polist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.polist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          if (!(filter.polist.tgl3)) {
            this.tblData.tgl3='';
            this.tblData.tgl4='';
          }
          this.showFilter=filtered;
          delete filter.polist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  let list =[];
                  if (this.viewOption=='Header') {
                      list = await procure.listinventorystockheader(this.tblData);
                  } else {
                      list = await procure.listinventorystock(this.tblData);
                  }
                  console.log('list inventorystock: ',list);
                  this.pagination=true;
                  this.isLoading=false; 
                  return "";        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              let list =[];
              if (this.viewOption=='Header') {
                  list = await procure.listinventorystockheader(this.tblData);
              } else {
                  list = await procure.listinventorystock(this.tblData);
              }
              console.log('#list inventorystock: ',list);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    async reloaddata(val) {
      // this.isLoading = true;
      this.tblData.customer_group = val;
      this.tblData.CustName='';
      this.tblData.customer_id = '';
      // this.tblData.customer = '';
      // this.isLoading = false;
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.tgl1='';
        this.tblData.tgl2='';
        this.tblData.itemname='';
        this.tblData.CustName='';
        this.tblData.customer_id='';
        this.tblData.byStock='';
        this.tblData.itemcategory='';
        this.tblData.DimVal='';
        this.tblData.customer_group = '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'itemname', 'CustName', 'customer_id', 'byStock', 'itemcategory'];
      let filtered = false;
      const polist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              polist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          polist.page=this.tblData.page;
          polist.limit=this.tblData.limit;
          polist.sortBy=this.tblData.sortBy;
          polist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.polist=polist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    deleteConfirm() {
        if (this.model.requestkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await procure.removerequest(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        this.disabledCloseVoid   = true;
      }
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },

    printdo: async function()
    {
      //console.log("#this.model: ", this.model);
      if (this.model.transferkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printdofromtransfer(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    }, 
    
    exportxlsInventoryStock: async function() {
        this.isLoading=true;
        try {
           const response = await procure.exportxlsInventoryStock(this.tblData);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'inventory_stock_list.xlsx');
            document.body.appendChild(link);
            link.click();
            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },    
    close(){
          router.push("home");
    }

  }
};
</script>
